import React from 'react'

type ButtonTYPE = {
  type: 'button' | 'submit' | 'reset'
  text: string
  arialabel?: string
}

const Button = ({ type, text, arialabel }: ButtonTYPE) => {
  return (
    <div className="text-center">
      <button
        type={type}
        name={type}
        className="c-button"
        aria-label={`${arialabel}`}
      >
        {text}
      </button>
    </div>
  )
}

export default Button
